<template>
  <div>
    <form action="">
      <v-card class="mb-4 pb-2">
        <v-toolbar dense elevation="0">
          <v-toolbar-title class="subtitle-1">{{
            $t("casinoSettings")
          }}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-row class="align-center pl-4 pr-4">
          <v-col cols="12 pb-0">
            <div class="d-flex overline justify-start align-center">
              <div class="grey--text">
                {{ $t("selectActiveGames") }}
              </div>
            </div>
          </v-col>

          <!-- <v-col>
            Saving for when there's more than one casino provider
            <div>
              <v-select
                v-model="casinoProvider"
                :label="$t('provider')"
                :items="casinoProviderList"
              ></v-select>
            </div>
          </v-col> -->
        </v-row>
        <v-card-text v-if="gamesLoaded">
          <v-text-field
            placeholder="Pesquisar por jogo"
            v-model="search"
            clearable
            prepend-icon="mdi-magnify"
            hide-details
            single-line
          ></v-text-field>

          <div v-if="gamesLoaded" class="mt-4 px-3">
            <v-row
              class="d-flex justify-start"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'pt-2'"
            >
              <div class="d-flex">
                <v-checkbox
                  v-show="!search"
                  v-model="checkboxes['all']"
                  color="primary"
                  class="mx-auto my-auto pt-7 pl-1"
                  @click="allClicked()"
                >
                </v-checkbox>
                <div class="my-1 text-h6 pt-5">
                  {{ $t("all") }}
                </div>
              </div>
            </v-row>
            <v-row
              v-for="(category, categoryIndex) in getGameList"
              :key="categoryIndex"
              class="d-flex justify-start"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'pt-2'"
            >
              <div class="d-flex">
                <CategorySlider
                  v-show="category.items.length > 0"
                  :data="category"
                  :categoryIndex="categoryIndex"
                  :checkboxes="checkboxes"
                  :search="search"
                  @gameClicked="gameClicked"
                  @categoryClicked="categoryClicked"
                />
              </div>
            </v-row>
          </div>
        </v-card-text>
        <v-container v-else fill-height fluid>
          <v-row align="center" justify="center">
            <v-col class="d-flex align-center justify-center">
              <v-progress-circular
                indeterminate
                color="info"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </form>
  </div>
</template>

<script>
import CategorySlider from "./CategorySlider";

export default {
  name: "casino-settings",
  components: {
    CategorySlider,
  },
  data: () => ({
    casinoProvider: "pp",
    casinoProviderList: [{ text: "Pragmatic Play", value: "pp" }],
    games: [],
    gamesLoaded: false,
    checkboxes: {},
    id_provedor: 1,
    gameList: [],
    gamesAmountByCategory: { all: -1 },
    search: "",
  }),

  computed: {
    skeletonPerCol() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "xs") {
        return 2;
      } else if (breakpoint == "md") {
        return 3;
      } else if (breakpoint == "lg") {
        return 4;
      } else if (breakpoint == "xl") {
        return 6;
      }

      return 6;
    },
    getGameList() {
      if (this.search && this.search.length > 2) {
        return this.games.map((category) => {
          let items = [];

          for (let game of category.items) {
            if (
              game.nome_jogo.toLowerCase().includes(this.search.toLowerCase())
            ) {
              items.push(game);
            }
          }

          return { ...category, items };
        });
      }

      return this.games;
    },
    getAllGames() {
      return this.games.flatMap((el) => el.items.map((el) => el.id));
    },
    getAllCategories() {
      return this.games.map((el) => el.id_tipo);
    },
  },

  async mounted() {
    const cachedGames = JSON.parse(sessionStorage.getItem("casinoGames"));

    if (cachedGames) {
      this.gameList = cachedGames;
    } else {
      const body = this.$formdata({
        domain: localStorage.getItem("operator"),
      });
      const endpoint = "/administrator/cassino/games/list";
      await this.$request
        .get(endpoint, body)
        .then((res) => {
          //   console.log("games/list response: ");
          //   console.log(res);
          if (res.dados) {
            sessionStorage.setItem("casinoGames", JSON.stringify(res.dados));
            this.gameList = res.dados;
          }
        })
        .catch((error) => console.log(error));
    }

    // Gera recursivamente objeto cujos atributos são as listas dos jogos
    //  de cada vertical (aba) do cassino
    this.gameList = this.gameList.reduce((accumulator, current) => {
      if (
        current.id_tipo === "bc" ||
        current.id_tipo === "bj" ||
        current.id_tipo === "rl"
      ) {
        current.id_tipo = "tg";
        current.category_name_en = "Table Games";
      }

      this.gamesAmountByCategory["all"]++;
      if (this.gamesAmountByCategory[current.id_tipo])
        this.gamesAmountByCategory[current.id_tipo]++;
      else this.gamesAmountByCategory[current.id_tipo] = 1;

      accumulator["all"] = [...(accumulator["all"] || []), current];
      accumulator[current.category_name_en] = [
        ...(accumulator[current.category_name_en] || []),
        current,
      ];
      return accumulator;
    }, {});
    delete this.gamesAmountByCategory["0"];
    // console.log("games by category: ", this.gamesAmountByCategory);

    this.groupAndOrderGamesByCategory();
    let activeGames = await this.$request
      .get("/administrator/cassino/games/listByOperator")
      .then((response) => {
        // console.log("active status: ", response);
        return response ? response.dados : [];
      })
      .catch((error) => console.log(error));

    // console.log("active games: ", activeGames);
    let activeGamesByCategory = { all: 0 };
    if (activeGames)
      activeGames.forEach((el) => {
        if (el.id_tipo === "bc" || el.id_tipo === "bj" || el.id_tipo === "rl") {
          el.id_tipo = "tg";
          el.category_name_en = "Table Games";
        }

        activeGamesByCategory["all"]++;
        if (activeGamesByCategory[el.id_tipo])
          activeGamesByCategory[el.id_tipo]++;
        else activeGamesByCategory[el.id_tipo] = 1;

        this.checkboxes[el.id_game] = true;
      });
    // console.log("active games by category: ", activeGamesByCategory);
    const self = this;
    for (const category in activeGamesByCategory) {
      if (
        activeGamesByCategory[category] === self.gamesAmountByCategory[category]
      )
        self.checkboxes[category] = true;
    }
    this.gamesLoaded = true;
  },

  methods: {
    allClicked() {
      for (let i of [...this.getAllGames, ...this.getAllCategories]) {
        // console.log(
        //   "i: ",
        //   i,
        //   "this.checkboxes[i]: ",
        //   this.checkboxes[i],
        //   "this.checkboxes['all']: ",
        //   this.checkboxes["all"]
        // );
        if (this.checkboxes[i] != this.checkboxes["all"])
          this.checkboxes[i] = this.checkboxes["all"];
      }
      this.checkboxes = { ...this.checkboxes };
      let body = {
        active_games: [],
        id_provedor: this.id_provedor,
        applyForAll: 1,
      };
      this.$request.post(
        "/administrator/cassino/games/" +
          (this.checkboxes["all"] ? "insertByOperator" : "deleteByOperator"),
        body
      );
    },
    categoryClicked(category, categoryIndex) {
      // console.log("raw games array: ", this.games);
      // console.log("category index: ", categoryIndex);
      // console.log("game: ", this.games[categoryIndex]);
      // Seleciona o checkbox "Todos" se todas as categorias estiverem
      // selecionadas e desseleciona caso alguma não esteja
      this.checkboxes["all"] = !this.getAllCategories.find(
        (el) => this.checkboxes[el] != true
      );
      let selectedGames = [];
      this.games[categoryIndex].items.forEach((game) => {
        if (this.checkboxes[game.id] != this.checkboxes[category]) {
          this.checkboxes[game.id] = this.checkboxes[category];
          selectedGames.push(game.id);
        }
      });
      this.checkboxes = { ...this.checkboxes };

      let body = {
        active_games: selectedGames,
        id_provedor: this.id_provedor,
        applyForAll: 0,
      };
      this.$request.post(
        "/administrator/cassino/games/" +
          (this.checkboxes[category] ? "insertByOperator" : "deleteByOperator"),
        body
      );
      // console.log("gameList to be changed: ", body);
    },

    async gameClicked(game, isActive) {
      this.checkboxes["all"] = false;
      if (!isActive) {
        if (this.checkboxes[game.id_tipo])
          this.checkboxes[game.id_tipo] = false;
      } else {
        // console.log(
        //   "items: ",
        //   this.games
        //     .find((el) => el.id_tipo === game.id_tipo)
        //     .items.find((el) => {
        //       !this.checkboxes[el.id];
        //     })
        // );
        this.checkboxes[game.id_tipo] =
          this.games
            .find((el) => el.id_tipo === game.id_tipo)
            .items.find((el) => this.checkboxes[el.id] != true) === undefined;

        if (this.checkboxes[game.id_tipo]) {
          this.checkboxes["all"] = !this.getAllCategories.find(
            (el) => this.checkboxes[el] != true
          );
        }
      }
      this.checkboxes = { ...this.checkboxes };
      // console.log("clicked game: ", game);
      // send api call to change game
      let body = {
        active_games: [game.id],
        id_provedor: this.id_provedor,
        applyForAll: 0,
      };
      this.$request.post(
        "/administrator/cassino/games/" +
          (isActive ? "insertByOperator" : "deleteByOperator"),
        body
      );
      // console.log("game: ", game.id_game, "isActive: ", isActive);
    },

    groupAndOrderGamesByCategory() {
      let slotsGames = [];
      let liveGames = [];
      let jackpotGames = [];
      let scratchGames = [];
      let tableGames = [];
      let crashGames = [];

      // let baccaratGames = [];
      // let blackjackGames = [];
      // let rouletteGames = [];

      for (let item in this.gameList) {
        if (item == "Crash Games") {
          crashGames.push(...this.gameList[item]);
        } else if (item == "Video Slots" || item == "Classic Slots") {
          slotsGames.push(...this.gameList[item]);
        } else if (item == "Live games") {
          liveGames.push(
            ...this.gameList[item].filter(
              (game) => game.id_game != "1301" && game.id_game != "114"
            )
          );
        } else if (item == "Jackpot") {
          jackpotGames.push(...this.gameList[item]);
        } else if (item == "Scratch card") {
          scratchGames.push(...this.gameList[item]);
        } else if (item == "Table Games") {
          tableGames.push(...this.gameList[item]);
        }

        // else if (item == "Baccarat" || item == "Baccarat New") {
        //   tableGames.push(...this.gameList[item]);
        // } else if (item == "Blackjack") {
        //   tableGames.push(...this.gameList[item]);
        // } else if (item == "Roulette") {
        //   tableGames.push(...this.gameList[item]);
        // }
      }

      const crashCategory = {
        category_name: "Crash Games",
        id_tipo: "cg",
        items: crashGames,
      };

      const slotCategory = {
        category_name: "Slots",
        id_tipo: "vs",
        items: slotsGames,
      };

      let liveCategory = null;

      if (this.$store.state.operator.casino == "2") {
        liveCategory = {
          category_name: this.$t("liveCasino"),
          id_tipo: "lg",
          items: liveGames,
        };
      }

      const jackpotCategory = {
        category_name: "Jackpot",
        id_tipo: "jp",
        items: jackpotGames,
      };

      const scratchCategory = {
        category_name: this.$t("scratch"),
        id_tipo: "sc",
        items: scratchGames,
      };

      const tableGamesCategory = {
        category_name: this.$t("tableGames"),
        id_tipo: "tg",
        items: tableGames,
      };

      // const baccaratCategory = {
      //   category_name: "Baccarat",
      //   id_tipo: "bc",
      //   items: baccaratGames,
      // };

      // const blackjackCategory = {
      //   category_name: "Blackjack",
      //   id_tipo: "bj",
      //   items: blackjackGames,
      // };

      // const rouletteCategory = {
      //   category_name: this.$t("roulette"),
      //   id_tipo: "rl",
      //   items: rouletteGames,
      // };

      const games = [crashCategory, slotCategory];

      if (liveCategory) {
        games.push(liveCategory);
      }

      games.push(jackpotCategory);
      games.push(scratchCategory);
      games.push(tableGamesCategory);

      this.games = games.filter((category) => category.items.length > 0);
    },
  },
};
</script>
